import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/login_bg.png'
import _imports_1 from '@/assets/gitee.svg'


const _withScopeId = n => (_pushScopeId("data-v-3c71d0f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "background",
    class: "bg-image"
  })
], -1))
const _hoisted_3 = { class: "login-container" }
const _hoisted_4 = { class: "left-content" }
const _hoisted_5 = { class: "brand-section" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"logo\" data-v-3c71d0f5><div class=\"logo-icon-box\" data-v-3c71d0f5><span data-v-3c71d0f5>&lt;/&gt;</span></div><span class=\"logo-text\" data-v-3c71d0f5>CodeBuild</span></div><h1 class=\"brand-title\" data-v-3c71d0f5> BUILD <span class=\"highlight-purple\" data-v-3c71d0f5>IDEAS.</span><br data-v-3c71d0f5> CREATE <span class=\"highlight-cyan\" data-v-3c71d0f5>THE FUTURE.</span></h1><p class=\"brand-subtitle\" data-v-3c71d0f5> Code. Build. Innovate.<br data-v-3c71d0f5> Turn imagination into reality. </p>", 3)
const _hoisted_9 = { class: "feature-icons" }
const _hoisted_10 = { class: "feature-item" }
const _hoisted_11 = { class: "icon-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CODE", -1))
const _hoisted_13 = { class: "feature-item" }
const _hoisted_14 = { class: "icon-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "IDEA", -1))
const _hoisted_16 = { class: "feature-item" }
const _hoisted_17 = { class: "icon-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "BUILD", -1))
const _hoisted_19 = { class: "feature-item" }
const _hoisted_20 = { class: "icon-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "REALIZE", -1))
const _hoisted_22 = { class: "right-content" }
const _hoisted_23 = { class: "login-card" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "welcome-title" }, [
  /*#__PURE__*/_createTextVNode("Welcome "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-purple" }, "Back!")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "welcome-subtitle" }, "Sign in to continue your creative journey", -1))
const _hoisted_26 = { class: "form-options" }
const _hoisted_27 = { class: "remember-me" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "forgot-password",
  href: "#"
}, "Forgot password?", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, [
  /*#__PURE__*/_createElementVNode("span", null, "or")
], -1))
const _hoisted_30 = { class: "social-login" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "gitee",
  class: "social-icon"
}, null, -1))
const _hoisted_32 = { class: "signup-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CodeOutlined = _resolveComponent("CodeOutlined")!
  const _component_BulbOutlined = _resolveComponent("BulbOutlined")!
  const _component_BoxPlotOutlined = _resolveComponent("BoxPlotOutlined")!
  const _component_RocketOutlined = _resolveComponent("RocketOutlined")!
  const _component_MailOutlined = _resolveComponent("MailOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_CodeOutlined)
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_BulbOutlined)
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_BoxPlotOutlined)
              ]),
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_RocketOutlined)
              ]),
              _hoisted_21
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _hoisted_25,
          _createVNode(_component_a_form, {
            ref: "loginForm",
            layout: "vertical",
            model: _ctx.form,
            rules: _ctx.rules
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                label: "Email",
                name: "cellphone"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.form.cellphone,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.cellphone) = $event)),
                    placeholder: "Enter your email"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_MailOutlined, { style: {"color":"rgba(255, 255, 255, 0.45)"} })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                label: "Password",
                name: "verifyCode"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input_password, {
                    value: _ctx.form.verifyCode,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.verifyCode) = $event)),
                    placeholder: "Enter your password"
                  }, {
                    prefix: _withCtx(() => [
                      _createVNode(_component_LockOutlined, { style: {"color":"rgba(255, 255, 255, 0.45)"} })
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, [
                  _createVNode(_component_a_checkbox, {
                    checked: _ctx.form.rememberMe,
                    "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.rememberMe) = $event))
                  }, null, 8, ["checked"]),
                  _createTextVNode(" Remember me ")
                ]),
                _hoisted_28
              ]),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    size: "large",
                    class: "login-btn",
                    loading: _ctx.isLoginLoading,
                    onClick: _ctx.login
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" SIGN IN ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ]),
                _: 1
              }),
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_a_button, {
                  size: "large",
                  class: "social-btn",
                  onClick: _ctx.goGiteeAuth
                }, {
                  default: _withCtx(() => [
                    _hoisted_31,
                    _createTextVNode(" Gitee ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createTextVNode("Don't have an account? "),
                _createVNode(_component_router_link, { to: "/signup" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Sign up")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ])
    ])
  ]))
}